import React from 'react';
import ContractOwnershipList from 'src/models/ContractOwnershipList';
import AttachLeaseholdCard from './AttachLeaseholdCard';

export interface ILeaseholdSearchResultsProps {
    onNavigate: (contractId: number, contractholdId: number, contractType: string) => void;
}

export type ILeaseholdSearchResultsStateProps = {
    searchResults: Array<ContractOwnershipList>;
    isLeaseholdSearchLoading: boolean;
    isAgreementFound: boolean;
};

type ILeaseholdSearchResultsPageProps = ILeaseholdSearchResultsProps & ILeaseholdSearchResultsStateProps;

const LeaseholdSearchResults = (props: ILeaseholdSearchResultsPageProps) => {
    const leaseholdSearchResults = () => {
        if (props.isLeaseholdSearchLoading) {
            return <div style={{ textAlign: 'center' }}>---Loading---</div>;
        } else if (props.searchResults.length > 0) {
            return (
                <div>
                    <div style={{ display: 'flex', padding: '.5rem' }}>
                        <div style={{ width: '12%' }}>Agreement Type</div>
                        <div style={{ width: '10%' }}>Agreement Number</div>
                        <div style={{ width: '10%' }}>Vol/Page | Inst#</div>
                        <div style={{ width: '10%' }}>Agreement Date</div>
                        <div style={{ width: '21%' }}>Lessor</div>
                        <div style={{ width: '21%' }}>Lessee</div>
                        <div style={{ width: '14%' }}>Status</div>
                    </div>

                    <div>{props.searchResults.map((contract, index) => contractCard(contract, index))}</div>
                </div>
            );
        } else if (props.isAgreementFound === false) {
            return <div style={{ textAlign: 'center' }}>---No Contract Ownership Found---</div>;
        } else {
            return (
                <div style={{ textAlign: 'center' }}>
                    ---Enter a Contract Ownership Number (with Type), or Book/Page or Instrument #, to search for existing contracts---
                </div>
            );
        }
    };

    const determineLeaseholdValidity = () => {
        if (props.isAgreementFound === true) {
            return (
                <span key="lh1">
                    <span>
                        <i id="LeaseholdFound" style={{ color: 'green', fontSize: '2rem' }} className="far fa-check-circle" />
                    </span>
                    <span style={{ color: 'green', marginLeft: '.5rem' }}>
                        {props.searchResults.length === 1
                            ? '1 matching contract found — click the row to attach'
                            : `${props.searchResults.length} matching contracts found — click a row to attach`}
                    </span>
                </span>
            );
        } else if (props.isAgreementFound === false) {
            return (
                <span key="lh2">
                    <i id="NoLeaseholdFound" style={{ color: 'red', fontSize: '2rem' }} className="fas fa-exclamation-triangle" />
                    <span style={{ color: 'red', marginLeft: '.5rem' }}>No Matching Contract Ownership Found</span>
                </span>
            );
        }
        return <span />;
    };

    const contractCard = (contract: ContractOwnershipList, index: number) => {
        return (
            <AttachLeaseholdCard
                agreement={contract}
                index={index}
                nav={true}
                newAgreement={true}
                onNavigate={props.onNavigate}
            />
        );
    };

    return (
        <div style={{ marginBottom: '1rem' }}>
            <div style={{ marginTop: '.5rem' }}>{determineLeaseholdValidity()}</div>

            <div>
                <div>{leaseholdSearchResults()}</div>
            </div>
        </div>
    );
};

export default LeaseholdSearchResults;


// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/ManageLeaseholdDialogComponents/LeaseholdSearchResults.tsx